/**
 * How far ahead of the viewport a lab-chart embed starts loading.
 *
 * Paired with the `dns-prefetch`/`preconnect` hints in `shared-components/nc/ChartOriginHints`,
 * because the two only work together: those hints warm a connection browsers drop after ~10s
 * idle, so an embed that waits until it is actually on screen pays the full DNS + TCP + TLS
 * handshake anyway. A screen's worth of lead is what puts the request inside that window.
 *
 * Both chart components read this rather than restating the literal — they lazy-load the same
 * kind of cross-origin embed for the same reason, and a margin that drifted apart on one of
 * them would quietly un-do the hints for half the review archive.
 *
 * Lives here, not beside the hints, so the `use-audio-chart` hook can read it without a hook
 * reaching up into the component layer.
 */
export const CHART_EMBED_LEAD_MARGIN = '600px 0px'
